<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
    text-align: center;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title=" Laporan Penyata Pemungut">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                        <z-input 
                        label="Tahun"  
                        name="tahun" 
                        v-model="cari.tahun" 
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td rowspan="2">Bil</td>
                                <td colspan="2">P.Penyata Pemungut</td>
                                <td colspan="2">Tempoh Pungutan</td>
                                <td colspan="2">Membayar</td>
                                <td colspan="9" style="text-align:center;">Dimasukira</td>
                                <td rowspan="2">No. Resit BN</td>
                                <td rowspan="2">Tarikh Resit BN</td>
                                <td rowspan="2">Kod Status</td>
                                <td rowspan="2">Amaun<br>(RM)</td>
                            </tr>
                            <tr>
                                <td>No. RUJ</td>
                                <td>Tarikh</td>
                                <td>Dari</td>
                                <td>Hingga</td>
                                <td>Jumlah</td>
                                <td>Jab</td>
                                <td>PTJ/PK</td>
                                <td>VOT</td>
                                <td>JAB</td>
                                <td>PTJ/PK</td>
                                <td>PROG/AKT</td>
                                <td>PROJEK</td>
                                <td>SETIA</td>
                                <td>CP</td>
                                <td>KOD AKAUN</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.items">
                                <td>{{ dt.no }}</td>
                                <td>{{ dt.no_ruj }}</td>
                                <td>{{ dt.tarikh }}</td>
                                <td>{{ dt.dari }}</td>
                                <td>{{ dt.hingga }}</td>
                                <td>{{ $zutil.currency(dt.amaun_resit) }}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>{{ dt.no_resit_perbendaharaan }}</td>
                                <td>{{ dt.tarikh_resit_perbendaharaan }}</td>
                                <td>{{ dt.status }}</td>
                                <td>{{ $zutil.currency(dt.amaun_penyata) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex>
            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-flex
                        v-if="table.meta.current_page"
                        class="justify-start align-center"
                    >
                        <pagination
                            class="xs11"
                            :max="table.meta.last_page"
                            :path="table.meta.path"
                            :current="table.meta.current_page"
                            :last_page="table.meta.last_page"
                            :links="table.meta.links"
                            @pageChanged="table.loadpg"
                        />
                    </w-flex>
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "kutipan/laporan/laporan_penyata_pemungut",
            reload: true,
            status: [
                {
                    value: 1,
                    label: "Aktif",
                },
                {
                    value: 2,
                    label: "Tidak Aktif",
                },
            ],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan/laporan/laporan_penyata_pemungut" },
                { label: "Laporan", route: "/kutipan/laporan/laporan_penyata_pemungut" },
                {
                    label: "Laporan Penyata Pemungut",
                    route: "/kutipan/laporan/laporan_penyata_pemungut",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", tahun: "" },
        };
    },
    methods: {
        search() {
            this.$inertia.visit(
                window.route("kutipan.laporan.laporan_penyata_pemungut") +
                    "?tarikh_dari=" +
                    this.cari.tarikh_dari +
                    "&tarikh_hingga=" +
                    this.cari.tarikh_hingga +
                    "&tahun=" +
                    this.cari.tahun,
                { preserveScroll: true }
            );
        },

        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", tahun: "" };
            this.search();
        },

        cetak() {
            window.open(this.service_laporan+'kutipan/laporan/laporan_penyata_pemungut/cetak?user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga+
            "&tahun=" + this.cari.tahun,'_blank');
            },
        },
        watch: {},
    mounted() {
        // console.log(this.datas);
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.tahun == "undefined") {
            this.cari.tahun = "";
        }
        // console.log(this.auth.user);
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
